// extracted by mini-css-extract-plugin
export default {"preview_wrap":"UploadFiles_preview_wrap__mck3+","preview_box":"UploadFiles_preview_box__SjE-O","image":"UploadFiles_image__6vwnf","name":"UploadFiles_name__U1bHR"};